import { createContext } from 'react'
import validations from '../validations'
import inputTypes from '../input-types'

export const ConfigContext = createContext({
	validations: validations,
	inputTypes: inputTypes,
})